<script>
  import { fly } from "svelte/transition";
  import { stylesColor } from "../stores/styles.js";

  export let title = "";
</script>

<style>
  .quote {
    min-height: 30vh;
    color: var(--color);
    transition: color 1s ease-in-out;
    @apply text-center;
  }
  h3 {
    @apply m-auto;
    @apply mb-6;

    @apply text-3xl;
    font-family: oxtail, serif;
    font-weight: 400;
    font-style: normal;
    max-width: 40vw;
    @apply opacity-50;
  }
  blockquote {
    @apply m-auto;
    @apply text-5xl;
    @apply px-20;
    max-width: 900px;
    /* max-width: 40vw; */
  }
</style>

<div class="quote" style="--color:{$stylesColor}">
  <h3 in:fly={{ x: 150, duration: 1500 }} out:fly={{ x: -150, duration: 1500 }}>
    {title}
  </h3>
  <blockquote
    in:fly={{ x: 200, duration: 1500 }}
    out:fly={{ x: -200, duration: 1500 }}>
    <slot />
  </blockquote>
</div>
